"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @private */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var ObjectTools = /** @class */ (function () {
    function ObjectTools() {
    }
    ObjectTools.map = function (obj, fn) {
        var mapped = Object.entries(obj).map(
        // eslint-disable-next-line @typescript-eslint/no-object-literal-type-assertion
        function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            var _c;
            return (_c = {}, _c[key] = fn(value, key), _c);
        });
        return Object.assign.apply(Object, __spread([{}], mapped));
    };
    ObjectTools.keys = function (o) {
        return Object.keys(o);
    };
    ObjectTools.indexBy = function (arr, keyFn) {
        if (typeof keyFn !== 'function') {
            var key_1 = keyFn;
            keyFn = (function (value) { return value[key_1].toString(); });
        }
        return this.fromArray(arr, function (val) {
            var _a;
            return (_a = {}, _a[keyFn(val)] = val, _a);
        });
    };
    ObjectTools.fromArray = function (arr, fn) {
        return Object.assign.apply(Object, __spread([{}], arr.map(fn)));
    };
    ObjectTools.forEach = function (obj, fn) {
        Object.entries(obj).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return fn(value, key);
        });
    };
    return ObjectTools;
}());
exports.default = ObjectTools;
//# sourceMappingURL=ObjectTools.js.map